import React from 'react';
import { Card } from '../shared/Card';
export const AIInsights = () => {
  const insights = [{
    id: 1,
    text: "You're most consistent mid-week! Wednesday is your strongest day.",
    icon: '📊'
  }, {
    id: 2,
    text: "At this pace, you'll hit 500 consistency minutes this month.",
    icon: '🔮'
  }, {
    id: 3,
    text: 'Your strength is improving faster than 80% of users with similar goals.',
    icon: '💪'
  }];
  return <div data-id="element-1302">
      <h2 className="font-medium text-lg mb-3" data-id="element-1303">AI Insights</h2>
      <div className="space-y-3" data-id="element-1304">
        {insights.map(insight => <Card key={insight.id} className="p-4" data-id="element-1305">
            <div className="flex" data-id="element-1306">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3 text-xl" data-id="element-1307">
                {insight.icon}
              </div>
              <div data-id="element-1308">
                <p data-id="element-1309">{insight.text}</p>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
};